import { extendTheme } from '@chakra-ui/react';
import {
  BG_ALTERNATIVE,
  BG_LAYER,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '70px',
    subHeading: '20px',
    body: '18px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(222,232,243,1)',
    bgSecondary: 'hsla(217, 24%, 52%, 1.00)',
    bgAlternative: 'rgba(245,248,251,1)',
    backgroundAssetColor: 'rgba(208,221,234,1)',
    mainColorText: 'rgba(113,135,174,1)',
    secondaryColorText: 'rgba(160,95,127,1)',
    alternativeColorText: 'rgba(255,255,255,1)',
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
  breakpoints: {
    base: '0em', // 0px
    xs: '360px', // Galaxy S8
    xp: '390px', // Iphone Pro
    xr: '410px', // Iphone XR
    lg: '480px',
    sm: '480px',
    md: '500px',
  },
};

export default extendTheme(theme);
